<app-action-menu-button
  [menuActions]="sortingMenuActions"
  [disabled]="isDisabled"
  [icon]="'filter-evidence-sort'"
  [type]="'basic'"
  [buttonSize]="'small'"
>
</app-action-menu-button>
